<template>
  <b-row class="mt-2">
    <b-col sm="12" v-if="header !== ''" style="font-weight:700; font-size:110%;">
      {{header}}
    </b-col>
    <b-col sm="12">
      <ul class="list">
        <li v-for="(item, i) in list" :key="i" :style="listItemStyle">
          <a v-if="item.isLink" :href="item.link" :class="{ arrow: arrows }">{{item.text}}</a>
          <a v-else :class="{ arrow: arrows }">{{item.text}}</a>
        </li>
      </ul>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'ulList',
  props: {
    header: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: () => { return [] }
    },
    listItemStyle: {
      type: String,
      default: 'padding-top: 10px; padding-bottom: 5px;font-weight: 300;'
    },
    arrows: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped>

.list {
  list-style-type: none;
  padding: 0;
}

.list > li {
  width: 100%;
}

.arrow:before {
  content: "›";
  font-weight: bold;
  padding-right: 8px;
}

</style>



// WEBPACK FOOTER //
// src/components/list/ULList.vue